import { z } from "zod";
/**
 * Access levels used across Woven Host.
 *
 * - `guest`: public visitor or authenticated account awaiting approval
 * - `lite`: manually approved basic access
 * - `pro`: can eventually create and manage servers
 * - `admin`: can access admin operations
 *
 * The browser and the control API must agree on these values, so they are
 * defined once here. Order matters only through {@link accessLevelRank}.
 */
export const ACCESS_LEVELS = ["guest", "lite", "pro", "admin"];
export const accessLevelSchema = z.enum(ACCESS_LEVELS);
export const DEFAULT_AUTHENTICATED_ACCESS = "guest";
const ACCESS_RANK = {
    guest: 0,
    lite: 1,
    pro: 2,
    admin: 3,
};
/** Numeric ordering used for minimum-access checks. */
export function accessLevelRank(level) {
    return ACCESS_RANK[level];
}
/** True when `level` grants at least `minimum`. */
export function hasAccess(level, minimum) {
    return accessLevelRank(level) >= accessLevelRank(minimum);
}
export function isGuest(level) {
    return level === "guest";
}
//# sourceMappingURL=access.js.map